import React from 'react';

import SkeletonBlock from 'Components/Skeleton/SkeletonBlock';
import SkeletonTakeOver from 'Components/Skeleton/SkeletonTakeOver';

/**
 * Deals page (OnSalePage) while it loads: the take over banner, then the Top Deals panel (CardPanelCarousel), one
 * large card beside two smaller ones, four from xl. The product listing is further down, below the fold.
 * Slots: those of SkeletonTakeOver.
 */
export default function DealsPageSkeleton() {
  return (
    <div className="DealsPageSkeleton">
      <SkeletonTakeOver />

      <section className="container DealsPageSkeleton__content">
        <SkeletonBlock className="SkeletonListing__heading" />

        <div className="DealsPageSkeleton__panel">
          <SkeletonBlock className="DealsPageSkeleton__card DealsPageSkeleton__card--large" />

          <div className="DealsPageSkeleton__support">
            <SkeletonBlock className="DealsPageSkeleton__card" />
            <SkeletonBlock className="DealsPageSkeleton__card" />
            <SkeletonBlock className="DealsPageSkeleton__card d-none d-xl-block" />
            <SkeletonBlock className="DealsPageSkeleton__card d-none d-xl-block" />
          </div>
        </div>
      </section>
    </div>
  );
}
